import type { ReactNode } from 'react'

import { AgencyDetailView } from './agency-detail.view'

export const AgencyDetailPage = (): ReactNode => <AgencyDetailView />
